import { KeyboardEventHandler, useCallback } from 'react';

export const useNumericOnlyKeyDown = () => {
  return useCallback<KeyboardEventHandler<HTMLInputElement>>((event) => {
    const acceptedSpecialKeys = [
      'Enter',
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (
      acceptedSpecialKeys.indexOf(event.key) === -1 &&
      !event.key.match(/^[0-9]$/)
    ) {
      event.preventDefault();
      return;
    }
  }, []);
};
